import { baseApi } from 'services'

import { Profile } from '@/types/unlock'

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfileFromUser: builder.query<any, void | number>({
      query: (userId) => `v2/profiles/?user=${userId}`,
    }),
    createProfile: builder.mutation<any, any>({
      query: (data) => ({
        url: `v2/profiles/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ApplicationProfiles', 'Alert'],
    }),
    addCoApplicant: builder.mutation<Profile, Partial<Profile>>({
      query: (data) => ({
        url: `v2/profiles/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'ApplicationProfiles',
        'Alert',
      ],
    }),
    getProfiles: builder.query<any[] | string[], any>({
      query: ({ ...params }) => {
        return {
          url: `v2/user/`,
          method: 'GET',
          params: params,
        }
      },
    }),
    getProfile: builder.query<any, any>({
      query: (id) => `v2/user/${id}/`,
    }),
  }),
})

export const {
  useLazyGetProfileFromUserQuery,
  useCreateProfileMutation,
  useAddCoApplicantMutation,
  useLazyGetProfileQuery,
  useLazyGetProfilesQuery,
} = profileApi
